import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Meta Pixel initialization
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
;
(function (f: any, b: Document, e: string, v: string) {
  let n: any, t: HTMLScriptElement, s: Element | null;
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e) as HTMLScriptElement;
  t.async = true;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s);
  }
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
window.fbq('init', '855275007473565');
window.fbq('track', 'PageView');
render(<App data-id="element-232" />, document.getElementById('root'));